import React from 'react';
import { ChevronRight } from 'lucide-react';

export const TopTermsTable = ({ terms, onSelect }) => {
  const max = Math.max(1, ...terms.map(t => t.count));
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm" data-testid="search-terms-table">
        <thead>
          <tr className="border-b border-gray-700 text-gray-400 text-xs uppercase tracking-wider">
            <th className="text-left py-3 px-3 font-medium w-10">#</th>
            <th className="text-left py-3 px-3 font-medium">Término</th>
            <th className="text-left py-3 px-3 font-medium w-1/3">Volumen</th>
            <th className="text-right py-3 px-3 font-medium">% del periodo</th>
            <th className="text-right py-3 px-3 font-medium">Prom. resultados</th>
            <th className="text-right py-3 px-3 font-medium">Sin resultados</th>
            <th className="text-right py-3 px-3 font-medium">Última</th>
            <th className="w-8" />
          </tr>
        </thead>
        <tbody>
          {terms.length === 0 ? (
            <tr><td colSpan={8} className="py-10 text-center text-gray-500">Sin búsquedas en este periodo</td></tr>
          ) : terms.map((t, i) => (
            <tr key={t.term} onClick={() => onSelect(t.term)} data-testid={`search-term-row-${i}`}
              className="border-b border-gray-700/50 hover:bg-orange-500/5 cursor-pointer transition-colors group">
              <td className="py-3 px-3 text-gray-500">{i + 1}</td>
              <td className="py-3 px-3 text-white font-medium group-hover:text-orange-300">{t.term}</td>
              <td className="py-3 px-3">
                <div className="flex items-center gap-2">
                  <div className="flex-1 h-2 rounded-full bg-gray-700/60 overflow-hidden">
                    <div className="h-full rounded-full bg-orange-500" style={{ width: `${(t.count / max) * 100}%` }} />
                  </div>
                  <span className="text-orange-400 font-bold tabular-nums w-8 text-right">{t.count}</span>
                </div>
              </td>
              <td className="py-3 px-3 text-right text-gray-400 tabular-nums">{t.share_pct}%</td>
              <td className={`py-3 px-3 text-right tabular-nums ${t.avg_results === 0 ? 'text-rose-400' : 'text-gray-300'}`}>{t.avg_results}</td>
              <td className={`py-3 px-3 text-right tabular-nums ${t.zero_results ? 'text-rose-400' : 'text-gray-500'}`}>{t.zero_results}</td>
              <td className="py-3 px-3 text-right text-gray-500 text-xs">{t.last_searched ? new Date(t.last_searched).toLocaleDateString('es-MX') : '—'}</td>
              <td className="py-3 px-2 text-gray-600 group-hover:text-orange-400"><ChevronRight className="w-4 h-4" /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
